import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Slot } from './styles';

/**
 * Temporary: only these customers see the widget slots
 * while the Picsize Widgets integration is being validated.
 */
const WIDGET_SLOTS_ENABLED_CUSTOMER_IDS = [4092];

export const useWidgetSlotsEnabled = () => {
  const customerId = useSelector(
    (state) => state.customer.user_data.customer_id
  );

  return WIDGET_SLOTS_ENABLED_CUSTOMER_IDS.includes(customerId);
};

/**
 * Empty container where Picsize Widgets (Lovable) injects its widgets.
 * It stays hidden while nothing is injected on it.
 */
const WidgetSlot = ({ name, className, style }) => {
  const widgetSlotsEnabled = useWidgetSlotsEnabled();

  if (!widgetSlotsEnabled) {
    return null;
  }

  return (
    <Slot
      id={`picsize-widget-${name}`}
      data-picsize-widget-slot={name}
      className={className}
      style={style}
    />
  );
};

WidgetSlot.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
};

WidgetSlot.defaultProps = {
  className: undefined,
  style: undefined
};

export default WidgetSlot;
